"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootView = void 0;
var React = __importStar(require("react"));
var keycloak_js_1 = __importDefault(require("keycloak-js"));
var keycloak_context_1 = require("../graphql/keycloak-context");
var Actions = __importStar(require("./root-actions"));
var main_view_1 = require("../main/main-view");
var graphql_client_1 = require("../graphql/graphql-client");
var styled_components_1 = __importDefault(require("styled-components"));
var KeyCloakButtons = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0.5em 0px;\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 600px) {\n    justify-content: center;\n    gap: 12px;\n  }\n"], ["\n  margin: 0.5em 0px;\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 600px) {\n    justify-content: center;\n    gap: 12px;\n  }\n"])));
function RootView(_a) {
    var _this = this;
    var state = _a.state, dispatch = _a.dispatch;
    var _b = __read(React.useState(undefined), 2), keycloakState = _b[0], setKeycloakState = _b[1];
    React.useEffect(function () {
        var onMount = function () { return __awaiter(_this, void 0, void 0, function () {
            var clientConfig, keycloak, authenticated;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("/client-config")];
                    case 1: return [4 /*yield*/, (_a.sent()).json()];
                    case 2:
                        clientConfig = _a.sent();
                        console.log(clientConfig);
                        keycloak = new keycloak_js_1.default({
                            realm: clientConfig.keycloak_realm,
                            url: clientConfig.keycloak_base_url,
                            clientId: clientConfig.keycloak_client_id,
                        });
                        return [4 /*yield*/, keycloak.init({
                                onLoad: "login-required",
                                checkLoginIframe: false,
                                // flow: "implicit",
                            })];
                    case 3:
                        authenticated = _a.sent();
                        // const userProfile = await keycloak.loadUserProfile();
                        // console.log("userProfile", userProfile);
                        // console.log("token", keycloak.token);
                        setKeycloakState({ keycloak: keycloak, authenticated: authenticated });
                        return [2 /*return*/];
                }
            });
        }); };
        onMount();
    }, []);
    var token = keycloakState && keycloakState.keycloak.token;
    var graphqlClient = React.useMemo(function () { return (token ? (0, graphql_client_1.createGraphqlClient)(token, "/graphql") : graphql_client_1.defaultGrapqhClient); }, [token]);
    return keycloakState && keycloakState.authenticated === true ? (React.createElement("div", { style: { overflow: "hidden" } },
        React.createElement(KeyCloakButtons, null,
            React.createElement("button", { onClick: function () { return keycloakState.keycloak.accountManagement(); } }, "Self-Service"),
            React.createElement("button", { onClick: function () { return gotoPlayground(keycloakState.keycloak.token); } }, "Playground"),
            React.createElement("button", { onClick: function () { return keycloakState.keycloak.logout(); } }, "Logout")),
        React.createElement(keycloak_context_1.KeycloakContext.Provider, { value: keycloakState.keycloak },
            React.createElement(graphql_client_1.GraphqlClientContext.Provider, { value: graphqlClient },
                React.createElement(main_view_1.MainView, { state: state.mainState, dispatch: function (a) { return dispatch(Actions.dispatchMain(a)); } }))))) : (React.createElement("div", null, "Logging in..."));
}
exports.RootView = RootView;
function gotoPlayground(token) {
    window.location.href = "/playground?headers=".concat(encodeURIComponent(JSON.stringify({
        Authorization: "Bearer ".concat(token),
    })));
}
var templateObject_1;
//# sourceMappingURL=root-view.js.map